module.exports = __webpack_public_path__ + "img/nemotron-data-mixture.633b804c.png";